import * as CryptoJS from 'crypto-js';
import { isValidAuthToken, parseStoredUser } from './auth';
const md5 = require('md5');
const key = md5("CMIS-APP");
export function authHeader() {
    const user = parseStoredUser();

    if (user && user.token && isValidAuthToken(user.token)) {
        return { 'Authorization': user.token };
    } else {
        return {};
    }
}

export function ucpEncrypt(reqBody, params) {
        if(typeof params == 'undefined'){
            params = {};
        }
        try{
            if(typeof params.noencrypt == 'undefined' || (typeof params.noencrypt != 'undefined' && params.noencrypt != 1)){
                if(typeof reqBody === 'object' && reqBody.constructor === Object){
                    reqBody = JSON.stringify(reqBody);
                }else if(Array.isArray(reqBody)){
                    reqBody = JSON.stringify(reqBody);
                }
                let encrypted = CryptoJS.AES.encrypt(reqBody, key).toString();
                return {data:encrypted};
            }else{
                return reqBody;
            }
        }
        catch(e){
            console.log("e ---- ", e);
            return {status:"error", success:0, message:"Invalid request", actual_error:e};
        }
    }


    export function ucpDecrypt(reqBody, params) {
        if(typeof params == 'undefined'){
                params = {};
            }
            try{
                if(typeof reqBody.data != 'undefined' && (typeof params.noencrypt == 'undefined' || (typeof params.noencrypt != 'undefined' && params.noencrypt != 1))){
                    const decrypted = CryptoJS.AES.decrypt(reqBody.data, key);
                    if (decrypted) {
                        try {
                            //console.log(decrypted);
                            const str = decrypted.toString(CryptoJS.enc.Utf8);
                            if (str.length > 0) {
                                return str;
                            } else {
                                return 'error 1';
                            } 
                        } catch (e) {
                            return 'error 2';
                        }
                    }
                    return 'error 3';
                }else{
                    if(typeof reqBody === 'object' && reqBody.constructor === Object){
                        reqBody = JSON.stringify(reqBody);
                    }else if(Array.isArray(reqBody)){
                        reqBody = JSON.stringify(reqBody);
                    }
                    return reqBody;
                }
            }
            catch(e){
                return {status:"error", success:0, message:"Invalid request"};
            }
        }